import { render, staticRenderFns } from "./EbookIntro.vue?vue&type=template&id=2872c6f2&"
import script from "./EbookIntro.vue?vue&type=script&lang=js&"
export * from "./EbookIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports